<!--
  * @Author: changyunxia
  * @Date:2020年10月12日 13:56:31
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月12日 13:56:31
  * @Description: 会议室预览 当日
  * @FilePath:@/components/meeting/MeetingDay.vue
-->
<template>
  <div class="bg">
    <meetingCalendar :meeting-type="'day'" @onConfirmMouth="onConfirmMouthFunc" />
    <div v-for="(item , index) in dataGroups" :key="index" class="meetin-Details-bg">
      <meetinDetails ref="Details" :time="false" :meeting-data="item.child" :index="index" />
      <div class="btn-bg">
        <div @click="confirm(item)">预定</div>
        <div @click="DetailsFunc(item)">详情</div>
      </div>
    </div>

    <div class="height" />
  </div>
</template>

<script>
import meetingCalendar from '@/components/meeting/meetingCalendar'
import meetinDetails from '@/components/meeting/meetinDetails'
export default {
  name: 'MeetingDay',
  components: {
    meetingCalendar,
    meetinDetails
  },
  props: {
    meetingData: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      dataGroups: [],
      // 所有会议室分组信息
      dataAllGroups: [],
      // 当前日期
      currentTime: this.$moment(new Date()).format('YYYY-MM-DD'),
      roomGroups: [
        { room_code: '01' },
        { room_code: '02' },
        { room_code: '03' },
        { room_code: '04' },
        { room_code: '05' },
        { room_code: '06' }
        // { room_code: '07' }
      ]
    }
  },
  computed: {},
  watch: {
    meetingData: {
      handler(newVal) {
        this.dataGroupsFunc(this.$moment(new Date()).format('YYYY-MM-DD'))
      },
      deep: true
    }
  },
  created() {
  },
  mounted() {
    this.dataGroupsFunc(this.$moment(new Date()).format('YYYY-MM-DD'))
  },
  methods: {
    // 点击预定按钮
    confirm(data) {
      if (data.child[0].startime === undefined) {
        data.child[0].startime = this.currentTime
      }
      this.$router.push({
        path: '/MeetingReservation',
        query: {
          type: 'day',
          data: data.child
        }
      })
    },
    // 查看详情
    DetailsFunc(data) {
      data.child.forEach(ele => {
        if (ele.startime === undefined) {
          ele.startime = this.currentTime
        }
      })
      if (!this.currentTime) {
        this.currentTime = this.$moment(new Date()).format('YYYY-MM-DD')
      }
      this.$emit('dialogshowFunc', true, this.currentTime, data.child)
    },
    onConfirmMouthFunc(val) {
      this.currentTime = val
      this.dataGroupsFunc(val)
      const Details = this.$refs.Details
      Details.forEach((ele, i) => {
        this.$refs.Details[i].bgNoneFunc()
      })
    },
    dataGroupsFunc(date) {
      var arr = this.meetingData.filter(item => item.startime === date)
      this.dataAllGroups = this.roomGroups.reduce((pre, cur) => {
        const target = pre.find(ee => ee.room_code === cur.room_code)
        if (target) {
          Object.assign(target, cur)
        } else {
          pre.push(cur)
        }
        return pre
      }, arr)
      if (arr.length > 0) {
        const dataInfo = {}
        this.dataAllGroups.forEach((item, index) => {
          const { room_code } = item
          if (!dataInfo[room_code]) {
            dataInfo[room_code] = {
              room_code,
              child: []
            }
          }
          dataInfo[room_code].child.push(item)
        })
        this.dataGroups = Object.values(dataInfo).sort((a, b) => a.room_code - b.room_code) // list 转换成功的数据
      } else {
        this.dataGroups = this.roomGroups
      }
    }
    //   相同会议室  分组
    // groupBy(array, f) {
    //   var groups = {}
    //   array.forEach(function(o) {
    //     var group = JSON.stringify(f(o))
    //     groups[group] = groups[group] || []
    //     groups[group].push(o)
    //   })
    //   return Object.keys(groups).map(function(group) {
    //     return groups[group]
    //   })
    // }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.bg{
    background: #f7f8fa;
}
.height{
  height: 60px;
  width: 100%;
  background: #f7f8fa;
}
.meetin-Details-bg{
  background: #ffffff;
  margin-bottom: 20px;
  padding: 10px 0 0 0;
}
.btn-bg{
  width: 100%;
  border-top: 1px solid #f8f8f8;
  height: 40px;
  display: flex;
  div{
    width: 50%;
    text-align: center;
    font-size: 14px;
    line-height: 40px;
    color: cornflowerblue;
  }
  div:nth-last-child(1){
      border-left: solid #f8f8f8 1px;
    }
}
</style>
